import React from 'react';

const features2 = [
  {
    title: 'Compensation Philosophy',
    img: '/assets/img/landing-page/features/comprehensive-strategies.webp',
    detail:
      'Most compensation philosophies are a percentile picked in a meeting. \u201cWe pay at the middle of the market\u201d is a budget decision wearing the clothes of a strategy, and the cost of getting it wrong shows up months later in the roles you cannot fill. WellPay models the options before you commit to one: what targeting higher actually costs across your own population, which roles it changes, and what you are choosing when you choose the middle. You see the philosophy up close, then decide.',
  },
  {
    title: 'Live Labor Market Data',
    img: '/assets/img/landing-page/features/ai-driven-data.webp',
    detail:
      'Your compensation surveys tell you what people are paid. They are also months old by the time you use them, and they cannot tell you what it takes to fill a role this month. WellPay reads your survey data against live labor market activity \u2014 what roles are being posted, at what rates, and how that market is moving right now. Not a replacement for your benchmarks. The layer they cannot give you.',
  },
  {
    title: 'Dynamic Rewards Strategies',
    img: '/assets/img/landing-page/features/dynamic-rewards.webp',
    detail:
      'The key to retaining top-tier talent starts with better rewards programs, and our platform is here to help you design incentives that keep your team engaged and productive across every department. With our insights, you can compare your current compensation programs with leading competitors and create streamlined implementation strategies to get your new offerings on the market fast. ',
  },
  {
    title: 'Job Architecture',
    img: '/assets/img/landing-page/features/job-architecture.webp',
    detail:
      'Job architecture is the link that ties your entire compensation strategy together, and we make it easier than ever to build a solid foundation for success through optimized job evaluations for every level of your operation. From executive and manager compensation to entry-level salaries, WellPay keeps your compensation structure balanced for current and future needs.',
  },
  {
    title: 'Rewards Team Insights',
    img: '/assets/img/landing-page/features/rewards-team-insight.webp',
    detail:
      'Whether you work in a department of 5 or 500, we ensure that every member of your team understands the intricacies of your rewards programs with educational resources that make it fast and easy to train team members and fellow HR partners on your new initiatives, leading to a more transparent culture.',
  },
  {
    title: 'Board Deck Materials',
    img: '/assets/img/landing-page/features/board-deck-strategies.webp',
    detail:
      'When it’s time to present your compensation programs to your executive team & board, WellPay can prepare your board decks and presentation materials that showcase the efficacy of your compensation strategies in an impactful way. This gives you and your team the power to track, analyze, and present your organization’s growth without the added stress of doing it all yourself.',
  },
];

function Compensation() {
  return (
    <div className="section mb-0">
      <div className="container" id="compensation">
        <div className="row mb-5">
          <div className="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
            <h2>Reimagine your compensation programs, The WellPay Way</h2>
          </div>
        </div>
        {features2.map((feature, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`feature_${i}`}>
            {i % 2 === 0 && (
              <div className="row feature-row">
                <div className="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                  <div className="feature-text-container">
                    <h2>{feature.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: feature.detail }} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-6 offset-lg-1 offset-md-0 position-relative">
                  <img
                    alt={feature.title}
                    src={feature.img}
                    className="feature-image-right feature-image-charts position-relative"
                    loading="lazy"
                  />
                </div>
              </div>
            )}
            {i % 2 === 1 && (
              <div className="row feature-row">
                <div className="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                  <img
                    alt={feature.title}
                    src={feature.img}
                    className="feature-image-left feature-image-charts"
                    loading="lazy"
                  />
                </div>
                <div className="col-12 col-md-6 offset-md-0 col-lg-5 offset-lg-1 d-flex align-items-center order-1 order-md-2">
                  <div className="feature-text-container">
                    <h2>{feature.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: feature.detail }} />
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Compensation;
